import { render, staticRenderFns } from "./CreateWallet.vue?vue&type=template&id=57904c0b&"
import script from "./CreateWallet.vue?vue&type=script&lang=js&"
export * from "./CreateWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports